export default "__VITE_ASSET__LSjb7mXt__"